import { Mic, Sparkles } from "lucide-react";

function VoiceMockup() {
  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg p-6 space-y-5">
      {/* Recording indicator */}
      <div className="flex items-center gap-4">
        <div className="relative">
          <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
            <Mic className="w-6 h-6 text-red-500" />
          </div>
          <div
            className="absolute inset-0 rounded-full border-2 border-red-400"
            style={{ animation: "landing-pulse-ring 2s ease-in-out infinite" }}
          />
        </div>
        <div className="flex-1">
          <div className="text-sm font-medium text-red-500">Recording...</div>
          <div className="flex items-end gap-1 mt-2 h-7">
            {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
              <div
                key={i}
                className="w-1 rounded-full bg-red-400/60"
                style={{
                  animation: "landing-waveform 0.8s ease-in-out infinite",
                  animationDelay: `${i * 0.1}s`,
                  height: "10px",
                }}
              />
            ))}
          </div>
        </div>
        <span className="text-xs text-warm-text-tertiary font-mono">0:03</span>
      </div>

      {/* Transcription */}
      <div className="bg-warm-bg-elevated rounded-lg p-3 border border-warm-border-subtle">
        <p className="text-sm text-warm-text-secondary italic">
          &quot;Add a meeting with the design team tomorrow at 2pm, high priority, under Work&quot;
        </p>
      </div>

      {/* Arrow */}
      <div className="flex justify-center">
        <div className="flex items-center gap-2 text-warm-blue text-xs font-medium">
          <Sparkles className="w-4 h-4" />
          AI Processing
        </div>
      </div>

      {/* Parsed result */}
      <div className="bg-warm-bg-base border border-warm-blue/30 rounded-lg p-3 space-y-2">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded border border-warm-border" />
          <span className="text-sm font-medium text-warm-text-primary">Meeting with design team</span>
        </div>
        <div className="flex flex-wrap gap-2 ml-6">
          <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-warm-blue/10 text-warm-blue">
            📅 Tomorrow 2:00 PM
          </span>
          <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-red-400/10 text-red-500">
            ⚡ High
          </span>
          <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-warm-bg-elevated text-warm-text-secondary border border-warm-border-subtle">
            📋 Work
          </span>
        </div>
      </div>
    </div>
  );
}

export default VoiceMockup;
